import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import {DESTINATION_DATA} from 'destination/destination-prop-types';
import withConfig from 'config/withConfig';

const DestinationSchema = ({
    destination: {
        latitude,
        longitude,
        relative_url: destinationUrl,
        city,
        description,
        state,
        street_address: address,
    },
    city: {relative_url: cityUrl, slug: citySlug},
    siteUrl,
}) => {
    const url = `${siteUrl}/${citySlug}/${destinationUrl}`;
    const cityUrlAbsolute = `${siteUrl}/${cityUrl}`;

    return (
        <Fragment>
            <meta itemProp="url" content={url} />
            <span
                itemProp="geo"
                itemScope
                itemType="http://schema.org/GeoCoordinates"
            >
                <meta itemProp="latitude" content={latitude} />
                <meta itemProp="longitude" content={longitude} />
            </span>
            {description && (
                <span
                    className="hidden"
                    itemProp="description"
                    dangerouslySetInnerHTML={{__html: description}}
                />
            )}
            <span
                itemProp="address"
                itemScope
                itemType="http://schema.org/PostalAddress"
            >
                {address && <meta itemProp="streetAddress" content={address} />}
                {city && <meta itemProp="addressLocality" content={city} />}
                {state && <meta itemProp="addressRegion" content={state} />}
            </span>
            <span
                itemProp="containedInPlace"
                itemScope
                itemType="http://schema.org/City"
            >
                <meta itemProp="name" content={city} />
                <meta itemProp="url" content={cityUrlAbsolute} />
            </span>
        </Fragment>
    );
};

DestinationSchema.propTypes = {
    destination: PropTypes.shape(DESTINATION_DATA).isRequired,
    city: PropTypes.object.isRequired,
    siteUrl: PropTypes.string.isRequired,
};

export default withConfig(['siteUrl'])(DestinationSchema);
